import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles'
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import SelectField from "@material-ui/core/Select/Select";
import FilledInput from "@material-ui/core/FilledInput";
import { checkRoutingNumber } from '../../../api/payment';
import forEach from "lodash/forEach";
import get from "lodash/get";
import isEmpty from "lodash/isEmpty";
import map from "lodash/map";
import padStart from 'lodash/padStart';
import pickBy from "lodash/pickBy";


const styles = theme => ({
  container: {
    '&>*': {
      paddingTop: '0px !important',
      paddingBottom: '0px !important',
    },
    '& input[type=number]::-webkit-outer-spin-button': { 
      '&::-webkit-outer-spin-button': {
        '-webkit-appearance': 'none',
      },
      '-webkit-appearance': 'none',
      margin: 0,
    },
    opacity: 1
  },
  formControl: {
    marginTop: theme.spacing.unit/2,
    marginBottom: theme.spacing.unit/2
  }
})


class AchForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      error: '',
      formData: {
        'AccountType': '0',  // 0=checking, 1=saving
        'BankName': '',
        'AccountNumber': '',
        'ABANumber': '',
        'NameOnAccount': '',
        'Save': 'true',
        'Amount': '0',
        'EmailAddress': '',
        'Address1': '',
        'Address2': '',
        'City': '',
        'State': '',
        'Zip': '',
        'Country': '',
        'Settlement': 'CA MEMON Check',
      },
      formErrors: {},
      didSubmit: false,
      disableBankName: true,
      transitNumber: '',
      bankNumber: ''
    };

    this.form = React.createRef();
    if (props.triggerSubmit) props.triggerSubmit(this.handleSubmit);
  }

  Input = ({classes = {}, InputLabelProps = {}, InputProps = {}, name, ...rest}) => {
    const className = classes.textField || get(this.props, ['classes', 'textField']);
    const {formErrors, didSubmit} = this.state;
    const hasError = !!formErrors[name];
    const onBlur = e => {
      if (didSubmit) {
        const formErrors = this.validateFormData();
        this.setState({formErrors});
      }
      const { onBlur } = InputProps;
      if (onBlur) {
        onBlur(e);
      }
    };
    return <TextField
      className={get(this.props, ['classes', 'formControl'])}
      name={name}
      error={hasError}
      fullWidth
      variant="filled"
      margin="normal"
      onChange={this.handleFormChange}
      {...rest}
      InputLabelProps={{
        shrink: true,
        ...InputLabelProps,
      }}
      InputProps={{
        className,
        disableUnderline: !hasError,
        ...InputProps,
        onBlur,
      }}
    />;
  };

  Select = ({options = [], classes = {}, ...props}) => {
    const className = classes.textField || get(this.props, ['classes', 'textField']);
    const {formErrors} = this.state;
    const hasError = !!formErrors[props.name];
    return (
      <FormControl className={get(this.props, ['classes', 'formControl'])} variant="filled" fullWidth margin="normal" error={hasError}>
        <InputLabel
          htmlFor={props.id}
          shrink
        >
          {props.label}
        </InputLabel>
        <SelectField
          autoWidth
          onChange={this.handleFormChange}
          {...props}
          native
          input={<FilledInput className={className} fullWidth name={props.name} id={props.id}
                              disableUnderline={!hasError}/>}
        >
          {
            map(options, option => <option key={option.value} value={option.value}>{option.label}</option>)
          }
        </SelectField>
      </FormControl>
    );
  };

  handleFormChange = event => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    this.setState(prevState => {
      const formData = {...prevState.formData};
      formData[name] = String(value);
      return {formData};
    });
  };

  handleSubmit = (e) => {
    if (e) e.preventDefault();
    const formErrors = this.validateFormData();
    this.setState({didSubmit: true, formErrors});
    const isValid = isEmpty(formErrors);
    if (this.props.onSubmit) this.props.onSubmit(isValid, this.state.formData);
  };

  validateFormData = () => {
    const formErrors = {};
    const {formData} = this.state;
    if (this.form && this.form.current && this.form.current.elements) {
      forEach(this.form.current.elements, (el) => {
        let value = (el.name === 'transitNumber' || el.name === 'bankNumber') ? this.state[el.name] : formData[el.name];
        if (el.required && isEmpty(value)) {
          formErrors[el.name] = true;
        }
      });
    }

    return pickBy(formErrors);
  };

  autoFillBankName = event => {
    const { countryName } = this.props;
    const value = countryName === 'CAN' ? this.state.formData.ABANumber : event.target.value;
    if (value) {
      checkRoutingNumber(value, countryName).then(({data}) => {
        if (data.bank) this.setState((prevState) => ({formData: {...prevState.formData, BankName: data.bank}}));
        else this.setState((prevState) => ({
          formData: {...prevState.formData, BankName: data.bank},
          disableBankName: false
        }));
      });
    }
  };

  handleTransitAndBankChange = event => {
    const target = event.target;
    const value = target.value;
    const name = target.name;
    this.setState({
      [name]: value,
    });
  };

  getABANumberFromTransitAndBank = ({bankNumber, transitNumber}) => {
    if (bankNumber && transitNumber) {
      return `${padStart(bankNumber, 4, '0')}${padStart(transitNumber, 5, '0')}`;
    }
    return '';
  }

  autoFillBankNameFromTransitAndBank = event => {
    const target = event.target;
    const name = target.name;
    const value = target.value ? padStart(target.value, name === 'transitNumber' ? 5 : 4, '0') : target.value;
    this.setState(prevState => {
      const { transitNumber, bankNumber } = prevState;
      const formData = {...prevState.formData};
      formData.ABANumber = this.getABANumberFromTransitAndBank({transitNumber, bankNumber, [name]: value});
      return {
        formData,
        [name]: value,
      };
    }, () => {
      this.autoFillBankName(event);
    });
  }

  render() {
    const { Input, Select } = this;
    const { classes, countryName } = this.props;
    const { formData, bankNumber, transitNumber } = this.state;

    return (
      <form ref={this.form} onSubmit={this.handleSubmit}>
        <Grid container alignItems='center' spacing={8} className={classes.container}>
          <Grid item xs={12} md={6}>
            {countryName === 'CAN' ? (
              <Grid container alignItems='center' spacing={8} className={classes.container}>
                <Grid item xs={6}>
                  <Input
                    required
                    value={transitNumber}
                    label="Transit Number"
                    name='transitNumber'
                    inputProps={{
                      minLength: 2,
                      maxLength: 20,
                      type: 'number',
                    }}
                    InputProps={{
                      onBlur: this.autoFillBankNameFromTransitAndBank,
                    }}
                    onChange={this.handleTransitAndBankChange}
                  />
                </Grid>
                <Grid item xs={6}>
                  <Input
                    required
                    value={bankNumber}
                    label="Bank Number"
                    name='bankNumber'
                    inputProps={{
                      minLength: 2,
                      maxLength: 20,
                      type: 'number'
                    }}
                    InputProps={{
                      onBlur: this.autoFillBankNameFromTransitAndBank,
                    }}
                    onChange={this.handleTransitAndBankChange}
                  />
                </Grid>
              </Grid>
            ) : (
              <Input
                required
                value={formData.ABANumber}
                name='ABANumber'
                label="Routing Number"
                inputProps={{
                  minLength: 2,
                  maxLength: 20,
                  type: 'number'
                }}
                InputProps={{
                  onBlur: this.autoFillBankName,
                }}
              />
            )}
          </Grid>
          <Grid item xs={12} md={6}>
            <Input
              required
              value={formData.AccountNumber}
              name='AccountNumber'
              label="Account Number"
              inputProps={{
                minLength: 2,
                maxLength: 20,
                type: 'number'
              }}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <Input
              disabled={this.state.disableBankName}
              required
              value={formData.BankName}
              name='BankName'
              label="Bank Name"
              inputProps={{
                minLength: 2,
                maxLength: 80,
              }}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <Select
              required
              name='AccountType'
              value={formData.AccountType}
              label='Account Type'
              type='select'
              options={[{label: 'Checking', value: '0'}, {label: 'Savings', value: '1'}]}
            />
          </Grid>
        </Grid>
      </form>
    );
  }
}

AchForm.propTypes = {
  ftniSessionId: PropTypes.string,
  triggerSumbit: PropTypes.func,
  onSubmit: PropTypes.func,
  countryName: PropTypes.string
};

export default withStyles(styles)(AchForm);
